import { Brain, Frown, Heart, Moon, Wind, Zap, type LucideIcon } from "lucide-react";

export interface SymptomOption {
  name: string;
  icon: LucideIcon;
  color: string;
}

export const SYMPTOM_OPTIONS: SymptomOption[] = [
  { name: "Cramps", icon: Zap, color: "text-orange-500" },
  { name: "Headache", icon: Brain, color: "text-purple-500" },
  { name: "Mood Changes", icon: Frown, color: "text-indigo-500" },
  { name: "Fatigue", icon: Moon, color: "text-slate-500" },
  { name: "Bloating", icon: Wind, color: "text-teal-500" },
  { name: "Breast Tenderness", icon: Heart, color: "text-pink-400" },
];
